import React from "react";
import { Grid2 } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LinkIcon from "@mui/icons-material/Link";
import {
  SECTION_LABELS,
  DATE_DISPLAY_OPTIONS,
  TIME_DISPLAY_OPTIONS,
  MINUTES_LABEL,
} from "../AppointmentDetailsModal.constants";
import {
  StyledSectionHeader,
  StyledSectionTitle,
  StyledInfoCard,
  StyledLabelValueRow,
  StyledLabel,
  StyledValue,
  StyledIconWrap,
  StyledSectionIconWrap,
  StyledVirtualMeetingLink,
} from "../AppointmentDetailsModal.styles";

const AppointmentDetailsModalScheduleAndLocationSection = ({ appointment }) => {
  const start = new Date(appointment.startTime);
  const end = new Date(appointment.endTime);
  const durationMinutes = Math.round((end - start) / (1000 * 60));
  const isVirtualLink = appointment.address?.startsWith("http");

  return (
    <Grid2 item size={{ xs: 12 }}>
      <StyledSectionHeader>
        <StyledSectionIconWrap>
          <CalendarTodayIcon />
        </StyledSectionIconWrap>
        <StyledSectionTitle>
          {SECTION_LABELS.SCHEDULE_AND_LOCATION}
        </StyledSectionTitle>
      </StyledSectionHeader>
      <StyledInfoCard>
        <Grid2 container spacing={2}>
          <Grid2 item size={{ xs: 12 }}>
            <StyledLabelValueRow>
              <StyledIconWrap>
                <CalendarTodayIcon />
              </StyledIconWrap>
              <StyledLabel variant="caption">
                {SECTION_LABELS.DATE_AND_TIME}
              </StyledLabel>
            </StyledLabelValueRow>
            <StyledValue variant="body2" bold>
              {start.toLocaleDateString("en-US", DATE_DISPLAY_OPTIONS)}
            </StyledValue>
            <StyledValue variant="body2" $mt={0.5}>
              {start.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })} -{" "}
              {end.toLocaleTimeString("en-US", TIME_DISPLAY_OPTIONS)}
            </StyledValue>
          </Grid2>

          <Grid2 item size={{ xs: 12 }}>
            <StyledLabelValueRow>
              <StyledIconWrap>
                <AccessTimeIcon />
              </StyledIconWrap>
              <StyledLabel variant="caption">
                {SECTION_LABELS.DURATION}
              </StyledLabel>
            </StyledLabelValueRow>
            <StyledValue variant="body2">
              {durationMinutes} {MINUTES_LABEL}
            </StyledValue>
          </Grid2>

          {isVirtualLink && (
            <Grid2 item size={{ xs: 12 }}>
              <StyledLabelValueRow>
                <StyledIconWrap>
                  <LinkIcon />
                </StyledIconWrap>
                <StyledLabel variant="caption">
                  {SECTION_LABELS.MEETING_LINK}
                </StyledLabel>
              </StyledLabelValueRow>
              <StyledVirtualMeetingLink
                href={appointment.address}
                target="_blank"
                rel="noopener noreferrer"
              >
                {appointment.address}
              </StyledVirtualMeetingLink>
            </Grid2>
          )}

          {appointment.address && !isVirtualLink && (
            <Grid2 item size={{ xs: 12 }}>
              <StyledLabelValueRow>
                <StyledIconWrap>
                  <LocationOnIcon />
                </StyledIconWrap>
                <StyledLabel variant="caption">
                  {SECTION_LABELS.LOCATION}
                </StyledLabel>
              </StyledLabelValueRow>
              <StyledValue variant="body2">
                {appointment.address}
              </StyledValue>
            </Grid2>
          )}
        </Grid2>
      </StyledInfoCard>
    </Grid2>
  );
};

export default AppointmentDetailsModalScheduleAndLocationSection;
